module.exports = __webpack_public_path__ + "media/images/smart_phone/portal/prev-91af9069d4c30dab19728de5ff14d30a.png";